class PopularProductsSlider extends HTMLElement {
  connectedCallback() {
    const slider = this.querySelector("[data-popular-slider]");
    const viewport = slider?.querySelector(".swiper");
    const pagination = slider?.querySelector("[data-popular-pagination]");
    const cursor = slider?.querySelector("[data-popular-cursor]");
    const cursorIcon = slider?.querySelector("[data-popular-cursor-icon]");
    const hotspots = slider ? Array.from(slider.querySelectorAll("[data-popular-hotspot]")) : [];

    if (!slider || !viewport || typeof Swiper === "undefined") return;
    if (slider.dataset.initialized === "true") return;

    const desktopColumns = Number(slider.dataset.columnsDesktop) || 4;
    const mobileColumns = Number(slider.dataset.columnsMobile) || 1;
    const tabletColumns = Math.max(1, Math.min(desktopColumns, 2));

    this.swiper = new Swiper(viewport, {
      slidesPerView: mobileColumns,
      spaceBetween: 12,
      speed: 300,
      allowTouchMove: true,
      watchOverflow: true,
      observer: true,
      observeParents: true,
      pagination: pagination
        ? {
            el: pagination,
            type: "progressbar"
          }
        : false,
      breakpoints: {
        750: {
          slidesPerView: tabletColumns,
          spaceBetween: 16
        },
        990: {
          slidesPerView: desktopColumns,
          spaceBetween: 20
        }
      }
    });

    if (cursor && cursorIcon) {
      slider.addEventListener("mousemove", (event) => {
        const x = event.clientX - cursor.offsetWidth / 2;
        const y = event.clientY - cursor.offsetHeight / 2;

        cursor.animate(
          { transform: `translate(${x}px, ${y}px)` },
          { duration: 100, fill: "forwards" }
        );
      });

      slider.addEventListener("mouseleave", () => {
        cursor.dataset.type = "";
        cursorIcon.className = "tabs-products__cursor-icon button button--simple";
      });

      hotspots.forEach((hotspot) => {
        hotspot.addEventListener("mouseenter", () => {
          const type = hotspot.dataset.popularHotspot || "";
          cursor.dataset.type = type;
          cursorIcon.className = `tabs-products__cursor-icon button button--simple ${type}`;
        });

        hotspot.addEventListener("mouseleave", () => {
          cursor.dataset.type = "";
          cursorIcon.className = "tabs-products__cursor-icon button button--simple";
        });

        hotspot.addEventListener("click", () => {
          if (hotspot.dataset.popularHotspot === "prev") this.swiper.slidePrev();
          if (hotspot.dataset.popularHotspot === "next") this.swiper.slideNext();
        });
      });
    }

    requestAnimationFrame(() => {
      slider.classList.add("is-ready");
      slider.dataset.initialized = "true";
    });
  }
}

if (!customElements.get("popular-products-slider")) {
  customElements.define("popular-products-slider", PopularProductsSlider);
}
